import {LobbyImage} from '@colonist/types'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {SocketChat} from '../../../../shared/scripts/socket/SocketChat'
import {Sound} from '../../../../shared/scripts/Sound'
import {createDivIn, createFormIn, createImgIn, createInputIn, createSpanIn, setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIUtilsChat} from '../../../../shared/scripts/ui_chat/UIUtilsChat.ts'

export class UIMRoomPlayersChatController {
    private readonly chatContainer: HTMLDivElement
    private readonly messagesContainer: HTMLDivElement
    private readonly chatInput: HTMLInputElement

    private userHasScrolledToBottom = true

    constructor(container: HTMLDivElement) {
        this.chatContainer = createDivIn(container, 'm-room-players-chat-container')
        this.messagesContainer = createDivIn(this.chatContainer, 'm-room-players-chat-messages-container')

        const formContainer = createFormIn(this.chatContainer, '')

        const inputContainer = createDivIn(formContainer, 'm-room-players-chat-input-container')
        this.chatInput = createInputIn(inputContainer, 'm-room-players-chat-input')
        this.chatInput.placeholder = clientI18n.t('strings:roomPage.chatInputPlaceholder')

        const sendButton = createDivIn(inputContainer, 'm-room-players-chat-send-button')
        createImgIn(sendButton, LobbyImage.SendArrow)

        sendButton.onclick = (event: Event) => this.handleChatSubmit(event)
        formContainer.onsubmit = (event: Event) => this.handleChatSubmit(event)

        this.messagesContainer.onscroll = () => {
            const scrolledToBottom = this.messagesContainer.scrollTop + this.messagesContainer.clientHeight == this.messagesContainer.scrollHeight
            if(scrolledToBottom) {
                this.userHasScrolledToBottom = true
                return
            }
            this.userHasScrolledToBottom = false
        }
    }

    receivedChatMessage(avatar: LobbyImage, message: string, username?: string) {
        Sound.playSound(Sound.SoundType.MessageNotification)
        this.createMessage(this.messagesContainer, avatar, message, username)
    }

    clearMessages() {
        setElementInnerHTML(this.messagesContainer, {key: 'strings:colonistCommon.utils.emptyString'})
        this.chatInput.value = ''
    }

    private createMessage(container: HTMLDivElement, avatar: LobbyImage, message: string, username: string = '') {
        const messageContainer = createDivIn(container, 'm-room-players-chat-message-container')
        if(username) message = ': ' + message

        const highlightedMessage = UIUtilsChat.replaceKeywordsWithImages((username ?? '') + message)

        createImgIn(messageContainer, avatar)
        createSpanIn(messageContainer, 'm-room-players-chat-message', {key: 'strings:colonistCommon.utils.#buffer', options: {value: highlightedMessage, interpolation: {escapeValue: false}}})

        if(this.userHasScrolledToBottom) messageContainer.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
    }

    private handleChatSubmit(event: Event) {
        event.preventDefault()
        if(this.chatInput.value.length == 0) return
        SocketChat.sendRoomChat(this.chatInput.value)
        this.chatInput.value = ''
    }
}
